import * as THREE from 'three'
require('three-orbitcontrols');

import printModel from '../../../3dapps/mixins/printModel'
import { baseURL } from "../../../request/request";

import { world3d, camera, renderer, currentMesh, updateBox, scene, makeVase, updateColor, color1, color2, } from './3dvase'
import XDialog from 'vux/src/components/x-dialog/index.vue'


export let currentColor1 = "#D53825";
export let currentColor2 = "#FBFCF4";



export default {
name: "vase",
mixins: [printModel],
components: {
XDialog,
},

data() {
return {
quotationName: "3D花瓶",
productType: "3D花瓶",
landscape: true,//竖屏状态要一直为true
showSize: false,
showPrint: false,
loading: false,
showTabList: true,
cur: 0, //默认选中第一个tab
tabTitle: ['花瓶', '颜色'],
showColor: false,
colorList: [
{
color: "#FD7D2B",
borderColor: "#C07AB8",
title: "橙色"
},
{
color: "#FF8080",
borderColor: "#EFCE07",
title: "黄色"
},
{
color: "#76BD2E",
borderColor: "#C07AB8",
title: "苹果绿"
},
{
color: "#2B62DF",
borderColor: "#9F4D95",
title: "天蓝"
},
{
color: "#B0B7BA",
borderColor: "#4F9D9D",
title: "银色"
},
{
color: "#FBAA3C",
borderColor: "#FF8080",
title: "金色"
},
{
color: "#373236",
borderColor: "#9F4D95",
title: "黑色"
},
{
color: "#FBFCF4",
borderColor: "silver",
title: "白色"
},
{
color: "#FFC4EA",
borderColor: "silver",
title: "鲜粉红"
},
{
color: "#D53825",
borderColor: "silver",
title: "红色"
},
{
color: "#F5CEB9",
borderColor: "silver",
title: "肤色"
},
],
vaseList: [],
flowerList: [],
modelPathList: [],
isvaseIndex: 0,
isflowersIndex: 0,
isColorIndex: 0,
boxData: {
size: {
w: 60, // 长
h: 50, // 宽
d: 40, // 高
t: 1, // 壁厚
},
},
selecttype: 'Alltype',//默认选中一整套
btnsList: [{
class: "btn_left",
isClick: true,
icon: require("../../../3dapps/imgs/编辑.png"),
iconClick: require("../../../3dapps/imgs/编辑-选中.png"),
title: "编辑",
}, {
class: "btn_content",
isClick: false,
icon: require("../../../3dapps/imgs/尺寸.png"),
iconClick: require("../../../3dapps/imgs/尺寸-选中.png"),
title: "尺寸",
}], //按钮列表
isColorbtnsList: [{
isColorClick1: false,
icon: require("../../../3dapps/imgs/编辑.png"),
iconClick: require("../../../3dapps/imgs/编辑-选中.png"),
title: "下",
}, {
isColorClick2: false,
icon: require("../../../3dapps/imgs/编辑.png"),
iconClick: require("../../../3dapps/imgs/编辑-选中.png"),
title: "上",
}],
printColorIndex: 11,
}
},
watch: {






},
mounted() {
const scope = this;


var mo = function (e) {
e.preventDefault();
}


scope.$nextTick(function () {
scope.$refs.vase.style.paddingTop = '0px';
scope.$refs.vase.style.overflow = 'hidden';
scope.$refs.canvasBox.addEventListener("touchmove", mo, false);
scope.$refs.canvas.addEventListener("touchmove", mo, false);
});


const contentDOM = scope.$refs.vase;

scope.loading = true;

world3d(scope.$refs.canvas);


const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}


setTimeout(function () {
scope.loading = false;
}, 1000)


scope.init3d(contentDOM, camera, renderer, resize1);
this.$request.post(baseURL + '/makeVase/getVaseList', {}).then(res => {
if (res.code === 0) {

scope.vaseList = res.obj.vases;
scope.flowerList = res.obj.flowers;


let vaseStl = res.obj.vases[0].modelPath;
makeVase(vaseStl, "vase");




}
}).catch(err => {
scope.$vux.toast.show({
type: 'cancel',
text: err.msg
})
console.log(err);
});
},
methods: {

handler(index) {

if (index === 0) {
this.showTabList = !this.showTabList;
this.showSize = false;
let isclick = this.btnsList[1].isClick;
if (isclick) {
this.$set(this.btnsList[1], `isClick`, !isclick);
}
} else {
this.showSize = !this.showSize;
this.showTabList = false;
let isclick = this.btnsList[0].isClick;
if (isclick) {
this.$set(this.btnsList[0], `isClick`, !isclick);
}
}
this.$set(this.btnsList[index], `isClick`, !this.btnsList[index].isClick);
},

selectVaseItem(index) {
this.isvaseIndex = index;
this.showTabList = false;
console.log("Index", index);

const scope = this;
scope.loading = true;
if (this.isvaseIndex >= 0) {
this.$request.post(baseURL + '/makeVase/getVaseList', {}).then(res => {
if (res.code === 0) {
let vaseList = res.obj.vases[this.isvaseIndex].modelPath;
makeVase(vaseList, "vase");
console.log("vase", vaseList);
}
setTimeout(function () {
scope.loading = false;
}, 2000);
}).catch(err => {
setTimeout(function () {
scope.loading = false;
}, 2000);
scope.$vux.toast.show({
type: 'cancel',
text: err.msg
})
console.log(err);
});
}
},


isColorClick(index) {
if (index === 0) {//第一种颜色
this.showColor = true;
this.showSize = false;
this.isColorClick1 = this.isColorbtnsList[0].isClick;
this.isColorClick2 = false;
if (this.isColorClick1) {
this.$set(this.isColorbtnsList[0], `isClick`, !this.isColorClick1);
}
console.log("第一种颜色");
} else if (index === 1) {//第二种颜色
this.isColorClick1 = false;
this.showColor = true;
this.showTabList = true;
this.isColorClick2 = this.isColorbtnsList[1].isClick;
if (this.isColorClick2) {
this.$set(this.isColorbtnsList[1], `isClick`, !this.isColorClick2);
}
console.log("第二种颜色");
}
this.$set(this.isColorbtnsList[index], `isClick`, !this.isColorbtnsList[index].isClick);
},




























goEditStyle() {
this.showTabList = !this.showTabList;
this.showSize = false;
this.showColor = false;
},


selectSize() {
this.showSize = !this.showSize;
this.showTabList = false;
this.showColor = false;
},


selectColor() {
this.showColor = !this.showColor;
this.showTabList = false;
this.showSize = false;
},


selectColorItem(index, item) {
this.isColorIndex = index;
this.showColor = false;
this.isColorClick1 = this.isColorbtnsList[0].isClick;

if (this.isColorClick1) {
this.color1 = item.color;
this.currentColor1 = this.color1;
updateColor(color1.r, color1.g, color1.b, color2.r, color2.g, color2.b);
console.log("color1", this.currentColor1);
} else {
this.color2 = item.color;
this.currentColor2 = this.color2;
updateColor(color1.r, color1.g, color1.b, color2.r, color2.g, color2.b);
console.log("color2", this.currentColor2);
}
},


isSelectVase() {
let vaseItem = this.$refs.vaseitem.value;
console.log("selecttype", vaseItem);
},

isSelectflower() {
let flowerItem = this.$refs.floweritem.value;
console.log("selecttype", flowerItem);
},

isSelectAllBoay() {
let allBoayItem = this.$refs.allboay.value;
console.log("selecttype", allBoayItem);
},


cancelPop() {

if (this.newlength == "" && this.newWidth == "" && this.newHeight == "" && this.newDept == ""
|| this.newlength == "" || this.newWidth == "" || this.newHeight == "" || this.newDept == "") {
this.showSize = true;
this.$vux.toast.show({
text: '请检查输入是否为空！',
type: "cancel",
time: 2000,
position: "middle",
})
this.boxData.size.w = 60;
this.boxData.size.h = 50;
this.boxData.size.d = 40;
this.boxData.size.t = 1;

}
this.showSize = false;
this.showCircleBtn = true;
},


isOKSize() {
if (this.boxData.size.w < 60) {
this.$vux.toast.show({
text: '最小长度为60毫米',
type: "warn",
time: 2000,
position: "middle",
});
return;
}
if (this.boxData.size.w > 300) {
this.$vux.toast.show({
text: '最大长度为300毫米',
type: "warn",
time: 2000,
position: "middle",
});
return;
}
if (this.boxData.size.h < 50) {
this.$vux.toast.show({
text: '最小宽度为50毫米',
type: "warn",
time: 2000,
position: "middle",
})
return;
}
if (this.boxData.size.h > 200) {
this.$vux.toast.show({
text: '最大宽度为200毫米',
type: "warn",
time: 2000,
position: "middle",
})
return;
}
if (this.boxData.size.d < 40) {
this.$vux.toast.show({
text: '最小高度为40毫米',
type: "warn",
time: 2000,
position: "middle",
})
return;
}
if (this.boxData.size.d > 200) {
this.$vux.toast.show({
text: '最大高度为200毫米',
type: "warn",
time: 2000,
position: "middle",
})
return;
}
if (this.boxData.size.t < 1) {
this.$vux.toast.show({
text: '最小壁厚为1毫米',
type: "warn",
time: 2000,
position: "middle",
})
return;
}
if (this.boxData.size.t > 9) {
this.$vux.toast.show({
text: '最大壁厚为9毫米',
type: "warn",
time: 2000,
position: "middle",
})
return;
}
this.showSize = false;
this.showCircleBtn = true;

},


makeStlBlob() {
let exporter = new THREE.STLExporter();
let group = currentMesh;

let result = exporter.parse(group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
return blob;
},


print() {
this.showSize = false;



if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showlowpriceHeight = true;
console.log("display:none 0就不显示", this.total);
}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showlowpriceHeight = false;
console.log("1就是显示");
}


if (!this.$common.getCookie('_token')) {
this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
});
console.log("common", this.$common.getCookie('_token'));

this.afterLoginShow = "print";
this.showPrint = true;
this.makeModelForPrint();
this.getPrice();
} else {
console.log("else");
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
this.getPrice();
});
}
},


getModelToPrint() {
let group = currentMesh;
return group;
},


getDelivery(materialId) {
let scope = this;
this.$request.post('/delivery/listDelivery', { materialId })
.then(function (data) {
console.log("data", data);
scope.deliveryDaysList = data.obj;


if (materialId === '409fbdd9-c3a9-11e9-af9b-00163e0e2a52'
|| materialId === '409fbcef-c3a9-11e9-af9b-00163e0e2a52'
|| materialId === '409fbcef-c3a9-11e9-af9b-00163e0e2a52'
|| materialId === '409fb9f4-c3a9-11e9-af9b-00163e0e2a52'
|| materialId === '409f85a9-c3a9-11e9-af9b-00163e0e2a52'
|| materialId === '409f8c14-c3a9-11e9-af9b-00163e0e2a52'
|| materialId === '409f8cad-c3a9-11e9-af9b-00163e0e2a52'
|| materialId === '409f8aca-c3a9-11e9-af9b-00163e0e2a52'
|| materialId === '409f823c-c3a9-11e9-af9b-00163e0e2a52'
|| materialId === '409fbc0a-c3a9-11e9-af9b-00163e0e2a52'
|| materialId === '409f865e-c3a9-11e9-af9b-00163e0e2a52') {

scope.deliveryDays = scope.deliveryDaysList[scope.deliveryDaysList.length - 1].days;
}
else {
scope.deliveryDays = scope.deliveryDaysList[scope.deliveryDaysList.length - 1].days;
console.log("scope.deliveryDays", scope.deliveryDays);

}
if (scope.materialId === '409f85a9-c3a9-11e9-af9b-00163e0e2a52') {
console.log("222");
alert("3333");
}

scope.getPrice();
});
},


loadMaterials(e) {
const scope = this;

this.$request.post('/SmallSoftware/listMaterials', { "materialType": "定制" }).then(function (res) {

scope.printMaterials = res.obj.sort((a, b) => a.density * a.price - b.density * b.price);


scope.printMaterials = res.obj;


scope.printMaterialIndex = 0;
scope.printColorIndex = 11;

scope.count = 1;
scope.deliveryDays = 7;
console.log("加载材质", scope.printMaterialIndex, scope.printColorIndex);
scope.getDelivery(scope.printMaterials[scope.printMaterialIndex].id);
});
},


printColorChange(e) {
this.showLowPrice = false;

this.printColorIndex = e.target.selectedIndex[11];
this.getPrice();
},



printMaterialChange(e) {
this.showLowPrice = false;
this.printMaterialIndex = e.target.selectedIndex;
this.printColorIndex = 11;
console.log('printMaterialIndex', this.printMaterialIndex);


this.getDelivery(this.selectedMaterial.id);
},


getPrice() {
if (!this.showPrint) return;

let _this = this;

this.$request.post('/SmallSoftware/create', {
length: _this.length,
width: _this.width,
height: _this.height,
volume: Math.ceil(_this.volume),
unit: 'mm',
minimumPrice: '',
minimumPriceSign: _this.lowPrice,
deliveryDays: _this.deliveryDays,
deliveryDiscount: _this.deliveryDiscount,
materialId: _this.printMaterials[_this.printMaterialIndex].id,
materialName: _this.printMaterials[_this.printMaterialIndex].materialName,
quantity: _this.count,
listSurface: [],
colorId: _this.printMaterials[_this.printMaterialIndex].listColor[_this.printColorIndex].id,
colorName: _this.printMaterials[_this.printMaterialIndex].listColor[_this.printColorIndex].colorName,
ossFileStl: '',
image: _this.image,
firstUpload: '',
quotationName: _this.quotationName,

productType: _this.productType,

}).then(function (data) {
console.log("data is", data);
if (data.code !== 0) {
_this.validOrder = false;
_this.errMsg = data.msg;
_this.$vux.toast.show({
text: data.msg,
type: "warn",
time: 2000,
position: "middle",
});
alert("error", data);
return;
}
_this.validOrder = true;
_this.price = data.obj.price;
_this.total = data.obj.total;
_this.deliveryDiscount = data.obj.deliveryDiscount;
_this.deliveryDays = data.obj.deliveryDays;


console.log("天数", _this.deliveryDays, _this.price, _this.total);
console.log("deliveryDiscount1", _this.deliveryDiscount);



if (_this.minimumPriceSign == 0 && _this.total <= 5 || _this.total == 5) {
_this.showlow = true;
_this.showStyle = false;
_this.showlowpriceHeight = true;
console.log("display:none 0就不显示", _this.total);
}
if (_this.minimumPriceSign == 1 && _this.total > 5 || _this.total > 5 || _this.minimumPriceSign == "") {
_this.showlow = false;
_this.showStyle = true;
_this.showlowpriceHeight = false;
console.log("1就是显示");
}
if (_this.materialId === '409f85a9-c3a9-11e9-af9b-00163e0e2a52') {
console.log("222");
}
})
},
},
}


// WEBPACK FOOTER //
// ./src/views/vase3d/scripts/index.js